import { Injectable, computed, inject, signal } from '@angular/core';
import { Creditor, CreditorService } from '../creditor.service';
import { ApiSessionService } from './api-session.service';

/** API-mode creditor scope. Labels are only shown when supplied by /me; no mock
 * creditor catalogue is injected into a real API session. */
@Injectable()
export class ApiCreditorService extends CreditorService {
  private readonly session = inject(ApiSessionService);
  private readonly selectedId = signal<string | null>(null);
  readonly creditors = computed<readonly Creditor[]>(() => (this.session.me()?.creditorIds ?? []).map(id => ({ id, code: id, name: id })));
  readonly active = computed(() => {
    const list = this.creditors();
    return list.find(c => c.id === this.selectedId()) ?? list[0] ?? null;
  });
  select(id: string): void { if (this.creditors().some(c => c.id === id)) this.selectedId.set(id); }
}
